// src/components/OrderRequirements/components/OrderRequirementTable.jsx
// ============================================================================
// BLOCK ORUI.TABLE.0 — Reusable table for Need To Order / Watch List
// ----------------------------------------------------------------------------
// - Edits order_qty inline
// - If order_qty becomes 0, parent moves row to Watch List
// - If order_qty becomes >0, parent moves row to Need To Order
// ============================================================================

import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

// Function to format the date display
function fmtDate(v) {
  if (!v) return '';
  try {
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return String(v);
    return d.toLocaleDateString();
  } catch {
    return String(v);
  }
}

export default function OrderRequirementTable({ title, rows, onQtyChange, dense }) {
  return (
    <Paper variant="outlined" sx={{ mb: 2 }}>
      <Typography
        variant="subtitle1"
        sx={{ px: 2, py: 1, fontWeight: 700, borderBottom: '1px solid', borderColor: 'divider' }}
      >
        {title}
      </Typography>

      <TableContainer>
        <Table size={dense ? 'small' : 'medium'}>
          <TableHead>
            <TableRow>
              <TableCell>itemno</TableCell>
              <TableCell align="right">Monthly Utilization</TableCell>
              <TableCell align="right">Est Inventory</TableCell>
              <TableCell align="right">Min On Shelf Qty</TableCell>
              <TableCell align="right">Std Order Qty</TableCell>
              <TableCell align="right">Date of Last Order</TableCell>
              <TableCell align="left">Last Order Qty</TableCell>
              <TableCell>ship_cadence</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((r) => (
              <TableRow key={`${r.itemno}::${r.lineno}`}>
                <TableCell>{r.itemno}</TableCell>
                <TableCell align="right">{Number(r.mo_utilization ?? 0).toFixed(2)}</TableCell>
                <TableCell align="right">{r.est_on_shelf ?? 0}</TableCell>
                <TableCell align="right">{r.min_on_shelf_qty ?? 0}</TableCell>
                <TableCell align="right" sx={{ width: 70 }}>
                  <TextField
                    size="small"
                    type="number"
                    inputProps={{ min: 0, step: 1 }}
                    value={r.order_qty ?? 0}
                    onChange={(e) => onQtyChange(r, e.target.value)}
                    sx={{ maxWidth: 120 }}
                  />
                </TableCell>
                <TableCell align="right">{fmtDate(r.last_order_date)}</TableCell>
                <TableCell align="left">{r.last_order_qty ?? ''}</TableCell>
                <TableCell>{r.ship_cadence}</TableCell>
              </TableRow>
            ))}

            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} sx={{ opacity: 0.7 }}>
                  None
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

OrderRequirementTable.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  onQtyChange: PropTypes.func.isRequired,
  dense: PropTypes.bool,
};

OrderRequirementTable.defaultProps = { dense: true };
